<template>
  <div
    class="card"
    :class="bindingClass"
    :style="{ margin: margin, padding: padding, height: height }"
  >
    <slot />
  </div>
</template>
<script lang="ts">
import { Options } from "vue-class-component";
import BaseTag from "../BaseTag.vue";

@Options({})
export default class IziCard extends BaseTag {}
</script>

<style lang="scss" scoped>
.card {
  background: #ffffff;
  box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14),
    0 1px 3px 0 rgba(0, 0, 0, 0.12);
  border-radius: 8px;
}
</style>
